export const CO2_G_PER_KM = 170;
export const co2SavedKg = (km) => Math.round(((km || 0) * CO2_G_PER_KM) / 1000);
export const co2Trees = (km) => Math.max(1, Math.round(co2SavedKg(km) / 21));
